import countries from "@/assets/ts/countries";
import {
  BankReferenceType,
  BranchCompanyType,
  ContactContryType,
  ContactTableView,
  ContactTableViewStatusType,
  ContactType,
  CreditLimitType,
  DepartmentType,
  MerchantType,
  PeakExceptionResponseCode,
  PrefixNameType,
  TypeOfPerson,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import { BankInformationModel, ContactCreateTemplateModel, PersonToContactModel } from "@/model/contact/contactModel";
import store from "@/store/index";
import { IsHaveThaiText } from "./merchantHelper";
import { GetTypeOfPersonBySearchedAddress } from "./shareHelper";

export function SetContactCreateTemplate(): ContactCreateTemplateModel {
  const contact: ContactCreateTemplateModel = {
    id: 0,
    contactBranchId: 0,
    modalCreateType: 1,
    logoUrl: "",
    taxId: {
      value: "",
      validateError: false,
    },
    branchTypeId: 1,
    branchCode: {
      value: "00000",
      validateError: false,
    },
    contactContryId: 1,
    contactCode: {
      value: "",
      validateError: false,
    },
    typeOfPerson: { value: 2, name: "" },
    contactName: "",
    typeCompany: {
      name: "",
      value: 0,
      front: "",
      back: "",
    },
    otherTypeCompany: "",
    verificationStatus: 0,
    companyName: {
      value: "",
      validateError: false,
    },
    prefixName: { value: PrefixNameType.Mr, name: "" },
    prefixOtherName: {
      value: "",
      validateError: false,
    },
    firstname: {
      value: "",
      validateError: false,
    },
    lastname: {
      value: "",
      validateError: false,
    },
    registeredAddress: {
      contactName: {
        value: "",
        validateError: false,
      },
      address: {
        value: "",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      building: {
        value: "",
        validateError: false,
      },
      city: {
        value: "",
        validateError: false,
      },
      state: {
        value: "",
        validateError: false,
      },
      district: {
        value: "",
        validateError: false,
      },
      amphoe: {
        value: "",
        validateError: false,
      },
      province: {
        value: "",
        validateError: false,
      },
      zipcode: {
        value: "",
        validateError: false,
      },
      country: { name: "Thailand", code: "TH" },
    },
    shippingAddress: {
      contactName: {
        value: "",
        validateError: false,
      },
      address: {
        value: "",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      building: {
        value: "",
        validateError: false,
      },
      city: {
        value: "",
        validateError: false,
      },
      state: {
        value: "",
        validateError: false,
      },
      district: {
        value: "",
        validateError: false,
      },
      amphoe: {
        value: "",
        validateError: false,
      },
      province: {
        value: "",
        validateError: false,
      },
      zipcode: {
        value: "",
        validateError: false,
      },
      country: { name: "Thailand", code: "TH" },
    },
    email: {
      value: "",
      validateError: false,
    },
    phoneNumber: {
      value: "",
      validateError: false,
    },
    faxNumber: {
      value: "",
      validateError: false,
    },
    website: {
      value: "",
      validateError: false,
    },
    personToContact: [
      {
        id: 0,
        prefixName: { value: PrefixNameType.None },
        prefixOtherName: {
          value: "",
          validateError: false,
        },
        firstName: {
          value: "",
          validateError: false,
        },
        lastName: {
          value: "",
          validateError: false,
        },
        nickName: {
          value: "",
          validateError: false,
        },
        department: { value: DepartmentType.None },
        departmentOther: {
          value: "",
          validateError: false,
        },
        position: {
          value: "",
          validateError: false,
        },
        email: {
          value: "",
          validateError: false,
        },
        phoneNumber: {
          value: "",
          validateError: false,
        },
      },
    ],
    bankInformation: [
      {
        id: 0,
        bank: {
          name: "",
          bankReferenceBankId: BankReferenceType.NONE,
        },
        accountName: {
          value: "",
          validateError: false,
        },
        accountNumber: {
          value: "",
          validateError: false,
        },
        bankBranch: {
          value: "",
          validateError: false,
        },
      },
    ],
    setDueDate: {
      dayForExpenses: {
        value: "7",
        validateError: false,
      },
      dayForInvoicePayment: {
        value: "7",
        validateError: false,
      },
      dueToExpenses: { name: "", value: 0 },
      dueToInvoicePayment: { name: "", value: 0 },
    },
    accountRecordSetting: {
      selectReceivableRecorded: { id: 7 },
      selectPayableRecorded: { id: 58 },
    },
    contactGroup: [],
    contactCreditLimit: {
      value: "0.00",
      validateError: false,
    },
    creditLimitSettingType: CreditLimitType.Default,
  };
  return contact;
}
export function SetHeaderTableContact() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "Code",
      sortBy: ContactTableView.code,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Name",
      sortBy: ContactTableView.name,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Action",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}
export function ConvertToContactTable(_contactTable: any) {
  const contactTableList: any = [];
  const contactTableCount = _contactTable.contactTableCount ? _contactTable.contactTableCount : 0;
  if (_contactTable.contactTableList && _contactTable.contactTableList.length > 0) {
    _contactTable.contactTableList.forEach((contactTable: any) => {
      contactTableList.push({
        id: contactTable.id,
        uuid: contactTable.uuid,
        merchantType: contactTable.merchantType,
        contactType: contactTable.contactType,
        name: contactTable.name,
        email: contactTable.email,
        accountPayable: contactTable.accountPayable,
        accountReceivable: contactTable.accountReceivable,
        taxId: contactTable.taxId,
        branchCode: contactTable.branchCode,
        postCode: contactTable.postCode,
        country: contactTable.country,
        province: contactTable.province,
        district: contactTable.district,
        subDistrict: contactTable.subDistrict,
        address: contactTable.address,
        code: contactTable.code,
        logoUrl: contactTable.logoUrl,
      });
    });
  }
  return { contactTableList: contactTableList, contactTableCount: contactTableCount };
}
export function ConvertToContactTemplateFromRd(_contactTemplateModelList: Array<any>) {
  const contactTemplateModelList: Array<any> = [];

  if (_contactTemplateModelList && _contactTemplateModelList.length > 0) {
    _contactTemplateModelList.forEach((item) => {
      const isThai = IsHaveThaiText(item.province);
      const isBranchCodeCorrect = item.branchCode && item.branchCode.length === 5;
      const isTaxIdCorrect = item.taxId && item.taxId.length === 13;

      if (isThai) {
        if (isTaxIdCorrect && isBranchCodeCorrect) {
          if (item.name.includes("พี ยู ยู เอ็น อินเทลลิเจนท์")) {
            if (item.taxId === "0105557083391" && item.branchCode === "00000") {
              contactTemplateModelList.push(item);
            }
          } else {
            contactTemplateModelList.push(item);
          }
        }
      } else {
        contactTemplateModelList.push(item);
      }
    });
  }

  return contactTemplateModelList;
}
export function SetTabsContactTable() {
  const tabs = [
    {
      name: "Table_Tap_All",
      length: 0,
      bgLengthColor: "blue",
      showtableCount: false,
      contactGroupId: 0,
      contactTableViewStatusType: ContactTableViewStatusType.All,
      tableViewStatusType: ContactTableViewStatusType.All,
      active: true,
    },

    {
      name: "Contact_Customer",
      length: 0,
      bgLengthColor: "blue",
      showtableCount: false,
      contactGroupId: 0,
      contactTableViewStatusType: ContactTableViewStatusType.ContactCustomer,
      tableViewStatusType: ContactTableViewStatusType.ContactCustomer,
      active: false,
    },
    {
      name: "Table_Tap_Seller",
      length: 0,
      bgLengthColor: "blue",
      showtableCount: false,
      contactGroupId: 0,
      contactTableViewStatusType: ContactTableViewStatusType.ContactSeller,
      tableViewStatusType: ContactTableViewStatusType.ContactSeller,
      active: false,
    },
    {
      name: "Table_Tap_Archive",
      length: 0,
      bgLengthColor: "blue",
      showtableCount: false,
      contactGroupId: 0,
      contactTableViewStatusType: ContactTableViewStatusType.Achieved,
      tableViewStatusType: ContactTableViewStatusType.Achieved,
      active: false,
    },
  ];
  return tabs;
}
export function UpdateTabsContactTableCount(tapsTable: any, tableCount: any) {
  tapsTable.forEach((item: any) => {
    switch (item.tableViewStatusType) {
      case ContactTableViewStatusType.All:
        item.length = tableCount.total;
        break;
      case ContactTableViewStatusType.Achieved:
        item.length = tableCount.isDeleted;
        break;
      case ContactTableViewStatusType.ContactCustomer:
        item.length = tableCount.incomeContactCount;
        break;
      case ContactTableViewStatusType.ContactSeller:
        item.length = tableCount.expenseContactCount;
        break;
    }
  });
  return tapsTable;
}

export function SetContactCreateTemplateBySearchedContactAddress(
  contactCreateTemplate: ContactCreateTemplateModel,
  searchedAddress: any
) {
  contactCreateTemplate.taxId.value = searchedAddress.taxId;
  if (searchedAddress.branchCode === "") {
    contactCreateTemplate.branchTypeId = BranchCompanyType.None;
  } else if (searchedAddress.branchCode === "00000") {
    contactCreateTemplate.branchTypeId = BranchCompanyType.Quarter;
  } else {
    contactCreateTemplate.branchTypeId = BranchCompanyType.Branch;
  }
  contactCreateTemplate.branchCode.value = searchedAddress.branchCode;
  contactCreateTemplate.logoUrl = searchedAddress.logoUrl;
  contactCreateTemplate.typeOfPerson = GetTypeOfPersonBySearchedAddress(searchedAddress.merchantType);
  contactCreateTemplate.typeCompany = { value: searchedAddress.merchantType, back: "", front: "", name: "" };
  if (
    contactCreateTemplate.typeOfPerson.value === TypeOfPerson.OrdinaryPerson &&
    searchedAddress.merchantType === MerchantType.OrdinaryPerson
  ) {
    searchedAddress.name = searchedAddress.name.trim();
    const fullName = searchedAddress.name.split(/ (.*)/);
    contactCreateTemplate.firstname.value = fullName.length > 0 ? fullName[0] : "";
    contactCreateTemplate.lastname.value = fullName.length > 1 ? fullName[1] : "";
    contactCreateTemplate.prefixName = { value: searchedAddress.personalNamePrefixTypeId, name: "" };
  } else {
    contactCreateTemplate.companyName.value = searchedAddress.name;
  }
  contactCreateTemplate.verificationStatus = searchedAddress.verificationStatus;
  contactCreateTemplate.registeredAddress.address.value = `${
    searchedAddress.no ? "เลขที่ " + searchedAddress.no : ""
  } ${searchedAddress.homeNo ? "หมู่ " + searchedAddress.homeNo : ""} ${
    searchedAddress.roomNo ? "ห้อง " + searchedAddress.roomNo : ""
  } ${searchedAddress.floorNo ? "ชั้น " + searchedAddress.floorNo : ""} ${
    searchedAddress.building ? "อาคาร " + searchedAddress.building : ""
  } ${searchedAddress.soi ? "ซอย " + searchedAddress.soi : ""} ${
    searchedAddress.road ? "ถนน " + searchedAddress.road : ""
  }`;
  contactCreateTemplate.registeredAddress.district.value = searchedAddress.subDistrict;
  contactCreateTemplate.registeredAddress.amphoe.value = searchedAddress.district;
  contactCreateTemplate.registeredAddress.province.value = searchedAddress.province;
  contactCreateTemplate.registeredAddress.zipcode.value = searchedAddress.postCode;
  contactCreateTemplate.email.value = searchedAddress.email ? searchedAddress.email : "";
  contactCreateTemplate.phoneNumber.value = searchedAddress.phone ? searchedAddress.phone : "";
  contactCreateTemplate.website.value = searchedAddress.website ? searchedAddress.website : "";
  contactCreateTemplate.faxNumber.value = searchedAddress.fax ? searchedAddress.fax : "";
}

export function SetContactCreateTemplateBySearchedContactAddressFailed(
  contactCreateTemplate: ContactCreateTemplateModel
) {
  contactCreateTemplate.logoUrl = "";
  contactCreateTemplate.firstname.value = "";
  contactCreateTemplate.lastname.value = "";
  contactCreateTemplate.companyName.value = "";
  contactCreateTemplate.verificationStatus = 0;
  contactCreateTemplate.registeredAddress.address.value = "";
  contactCreateTemplate.registeredAddress.district.value = "";
  contactCreateTemplate.registeredAddress.amphoe.value = "";
  contactCreateTemplate.registeredAddress.province.value = "";
  contactCreateTemplate.registeredAddress.zipcode.value = "";
  contactCreateTemplate.email.value = "";
  contactCreateTemplate.phoneNumber.value = "";
  contactCreateTemplate.website.value = "";
  contactCreateTemplate.faxNumber.value = "";
}

function BankInformation(_bankInfoList: Array<BankInformationModel>) {
  const bankInfoTemplate = [];
  if (_bankInfoList !== null) {
    for (let count = 0; count < _bankInfoList.length; count++) {
      const bankInfo = _bankInfoList[count];
      const bankInfoItem = {
        id: bankInfo.id,
        bankName: bankInfo.bank.name,
        accountNumber: bankInfo.accountNumber.value,
        accountName: bankInfo.accountName.value,
        branch: bankInfo.bankBranch.value,
        bankReferenceBankId: bankInfo.bank.bankReferenceBankId >= 0 ? bankInfo.bank.bankReferenceBankId : null,
      };
      bankInfoTemplate.push(bankInfoItem);
    }
  }
  return bankInfoTemplate;
}
function ToContactGroupIdList(_contactGroupList: any) {
  const contactGroupIdList = [];
  if (_contactGroupList !== null) {
    for (let count = 0; count < _contactGroupList.length; count++) {
      contactGroupIdList.push(_contactGroupList[count].contactGroupId);
    }
  }
  return contactGroupIdList;
}
function PersonToContact(_personToContactList: Array<PersonToContactModel>) {
  const personToContactTemplate = [];
  if (_personToContactList !== null) {
    for (let count = 0; count < _personToContactList.length; count++) {
      const personContact = _personToContactList[count];
      const personContactItem = {
        id: personContact.id,
        firstname: personContact.firstName.value,
        lastname: personContact.lastName.value,
        nickname: personContact.nickName.value,
        position: personContact.position.value,
        personPhone: personContact.phoneNumber.value,
        personEmail: personContact.email.value,
        isMainPerson: 1,
        isSendEmail: 1,
        personalNamePrefixTypeId: personContact.prefixName.value,
        personalNamePrefixOther: personContact.prefixOtherName.value,
        departmentTypeId: personContact.department.value,
        departmentOther: personContact.departmentOther.value,
      };
      personToContactTemplate.push(personContactItem);
    }
  }
  return personToContactTemplate;
}

export function InputInsertContactTemplate(_contact: ContactCreateTemplateModel) {
  const contact = {
    id: _contact.id,
    name:
      _contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
      _contact.typeCompany.value == MerchantType.OrdinaryPerson
        ? _contact.firstname.value.toString().trim() + " " + _contact.lastname.value.toString().trim()
        : _contact.companyName.value.toString().trim(),
    isVat: 0,
    email: _contact.email.value,
    phone: _contact.phoneNumber.value,
    address: {
      address: _contact.shippingAddress.address.value,
      subDistrict: _contact.contactContryId == 1 ? _contact.shippingAddress.district.value : "",
      district:
        _contact.contactContryId == 1 ? _contact.shippingAddress.amphoe.value : _contact.shippingAddress.city.value,
      province:
        _contact.contactContryId == 1 ? _contact.shippingAddress.province.value : _contact.shippingAddress.state.value,
      country: _contact.shippingAddress.country ? _contact.shippingAddress.country.name : "",
      road: _contact.contactContryId == 1 ? null : _contact.shippingAddress.road.value,
      building: _contact.contactContryId == 1 ? null : _contact.shippingAddress.building.value,
      postCode: _contact.shippingAddress.zipcode.value,
    },
    merchantType: _contact.typeCompany.value,
    contactName: _contact.shippingAddress.contactName.value,
    fax: _contact.faxNumber.value,
    website: _contact.website.value,
    code: _contact.contactCode.value,
    invoiceIncomeType: _contact.setDueDate.dueToInvoicePayment.value,
    invoiceIncomeValue: _contact.setDueDate.dayForInvoicePayment.value,
    accountsReceivableAccountId: _contact.accountRecordSetting.selectReceivableRecorded.id,
    invoiceExpenseType: _contact.setDueDate.dueToExpenses.value,
    invoiceExpenseValue: _contact.setDueDate.dayForExpenses.value,
    accountsPayableAccountId: _contact.accountRecordSetting.selectPayableRecorded.id,
    personalNamePrefixType: _contact.prefixName.value,
    personalNamePrefixOther: _contact.prefixName.value == PrefixNameType.Other ? _contact.prefixOtherName.value : null,
    taxId: _contact.taxId.value,
    bankInformation: BankInformation(_contact.bankInformation),
    personToContact: PersonToContact(_contact.personToContact),
    contactGroupIdList: ToContactGroupIdList(_contact.contactGroup),
    contactBranchModel: {
      id: _contact.contactBranchId,
      name: _contact.registeredAddress.contactName.value,
      branchCode: _contact.branchTypeId == 1 ? "00000" : _contact.branchCode.value,
      address: {
        address: _contact.registeredAddress.address.value,
        subDistrict: _contact.contactContryId == 1 ? _contact.registeredAddress.district.value : "",
        district:
          _contact.contactContryId == 1
            ? _contact.registeredAddress.amphoe.value
            : _contact.registeredAddress.city.value,
        province:
          _contact.contactContryId == 1
            ? _contact.registeredAddress.province.value
            : _contact.registeredAddress.state.value,
        country: _contact.registeredAddress.country.name,
        road: _contact.contactContryId == 1 ? null : _contact.registeredAddress.road.value,
        building: _contact.contactContryId == 1 ? null : _contact.registeredAddress.building.value,
        postcode: _contact.registeredAddress.zipcode.value,
      },
    },
    contactCreditLimit:
      _contact.creditLimitSettingType === CreditLimitType.Custom ? _contact.contactCreditLimit.value : 0,
    creditLimitSettingType: _contact.creditLimitSettingType,
  };
  return contact;
}

export function InputInsertContactTemplateBasic(
  _contact: ContactCreateTemplateModel,
  contactTemplateDefault: ContactCreateTemplateModel
) {
  const contactTemplate = contactTemplateDefault;
  contactTemplate.id = _contact.id;
  contactTemplate.taxId = _contact.taxId;
  contactTemplate.branchCode = _contact.branchCode;
  contactTemplate.branchTypeId = _contact.branchTypeId;
  contactTemplate.contactContryId = _contact.contactContryId;
  contactTemplate.typeCompany = _contact.typeCompany;
  contactTemplate.typeOfPerson = _contact.typeOfPerson;
  contactTemplate.companyName = _contact.companyName;
  contactTemplate.firstname = _contact.firstname;
  contactTemplate.lastname = _contact.lastname;
  contactTemplate.prefixName = _contact.prefixName;
  contactTemplate.prefixOtherName = _contact.prefixOtherName;
  contactTemplate.registeredAddress.address = _contact.registeredAddress.address;
  contactTemplate.registeredAddress.district = _contact.registeredAddress.district;
  contactTemplate.registeredAddress.amphoe = _contact.registeredAddress.amphoe;
  contactTemplate.registeredAddress.province = _contact.registeredAddress.province;
  contactTemplate.registeredAddress.contactName = _contact.registeredAddress.contactName;
  contactTemplate.registeredAddress.zipcode = _contact.registeredAddress.zipcode;
  contactTemplate.registeredAddress.country = _contact.registeredAddress.country;
  contactTemplate.registeredAddress.building = _contact.registeredAddress.building;
  contactTemplate.registeredAddress.road = _contact.registeredAddress.road;
  contactTemplate.registeredAddress.state = _contact.registeredAddress.state;
  contactTemplate.registeredAddress.city = _contact.registeredAddress.city;
  contactTemplate.email = _contact.email;
  contactTemplate.phoneNumber = _contact.phoneNumber;
  contactTemplate.faxNumber = _contact.faxNumber;
  contactTemplate.website = _contact.website;
  contactTemplate.contactCode = _contact.contactCode;
  contactTemplate.contactGroup = _contact.contactGroup;
  contactTemplate.creditLimitSettingType = _contact.creditLimitSettingType;
  return contactTemplate;
}

function ValidateContactError(contact: ContactCreateTemplateModel) {
  if (
    !contact.prefixOtherName.validateError &&
    !contact.registeredAddress.contactName.validateError &&
    !contact.registeredAddress.address.validateError &&
    !contact.registeredAddress.road.validateError &&
    !contact.registeredAddress.building.validateError &&
    !contact.registeredAddress.city.validateError &&
    !contact.registeredAddress.state.validateError &&
    !contact.registeredAddress.district.validateError &&
    !contact.registeredAddress.amphoe.validateError &&
    !contact.registeredAddress.province.validateError &&
    !contact.registeredAddress.zipcode.validateError &&
    !contact.shippingAddress.contactName.validateError &&
    !contact.shippingAddress.address.validateError &&
    !contact.shippingAddress.road.validateError &&
    !contact.shippingAddress.building.validateError &&
    !contact.shippingAddress.city.validateError &&
    !contact.shippingAddress.state.validateError &&
    !contact.shippingAddress.district.validateError &&
    !contact.shippingAddress.amphoe.validateError &&
    !contact.shippingAddress.province.validateError &&
    !contact.shippingAddress.zipcode.validateError &&
    !contact.email.validateError &&
    !contact.phoneNumber.validateError &&
    !contact.faxNumber.validateError &&
    !contact.website.validateError &&
    !contact.setDueDate.dayForExpenses.validateError &&
    !contact.setDueDate.dayForInvoicePayment.validateError &&
    !contact.lastname.validateError &&
    !contact.contactCode.validateError &&
    !contact.setDueDate.dayForInvoicePayment.validateError &&
    !contact.setDueDate.dayForExpenses.validateError &&
    !contact.contactCreditLimit.validateError &&
    !(contact.companyName.validateError || contact.firstname.validateError)
  ) {
    return true;
  } else {
    return false;
  }
}
function ValidateContactErrorList(contact: ContactCreateTemplateModel) {
  let isCheckValidateContact = false;
  if (contact.personToContact !== null) {
    for (let count = 0; count < contact.personToContact.length; count++) {
      if (
        !contact.personToContact[count].firstName.validateError &&
        !contact.personToContact[count].lastName.validateError &&
        !contact.personToContact[count].nickName.validateError &&
        !contact.personToContact[count].position.validateError &&
        !contact.personToContact[count].email.validateError &&
        !contact.personToContact[count].phoneNumber.validateError
      ) {
        isCheckValidateContact = true;
      }
    }
  }
  return isCheckValidateContact;
}
function ValidateContactBankAccountErrorList(contact: ContactCreateTemplateModel) {
  let isCheckValidateContact = false;
  if (contact.bankInformation !== null) {
    for (let count = 0; count < contact.bankInformation.length; count++) {
      if (
        !contact.bankInformation[count].accountName.validateError &&
        !contact.bankInformation[count].accountNumber.validateError &&
        !contact.bankInformation[count].bankBranch.validateError
      ) {
        isCheckValidateContact = true;
      }
    }
  }
  return isCheckValidateContact;
}

export function ValidateInsertContact(contact: ContactCreateTemplateModel) {
  if (
    contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
    contact.typeCompany.value == MerchantType.OrdinaryPerson
  ) {
    if (contact.firstname.value == "" || contact.firstname.value.length > 40) {
      contact.firstname.validateError = true;
    } else {
      contact.firstname.validateError = false;
    }
    if (contact.lastname.value.length > 40) {
      contact.lastname.validateError = true;
    } else {
      contact.lastname.validateError = false;
    }
    if (contact.prefixName.value == PrefixNameType.Other) {
      if (
        contact.prefixOtherName.value == "" ||
        (contact.prefixOtherName.value && contact.prefixOtherName.value.length > 32)
      ) {
        contact.prefixOtherName.validateError = true;
      } else {
        contact.prefixOtherName.validateError = false;
      }
    }
    contact.companyName.validateError = false;
  } else {
    if (contact.companyName.value == "") {
      contact.companyName.validateError = true;
    } else {
      contact.companyName.validateError = false;
    }
    contact.firstname.validateError = false;
    contact.lastname.validateError = false;
    contact.prefixOtherName.validateError = false;
  }

  if (contact.contactCode.value == "") {
    contact.contactCode.validateError = true;
  }
  if (contact.setDueDate.dayForExpenses.value.ToNumber() > 366) {
    contact.setDueDate.dayForExpenses.validateError = true;
  }
  if (contact.setDueDate.dayForInvoicePayment.value.ToNumber() > 366) {
    contact.setDueDate.dayForInvoicePayment.validateError = true;
  }
  if (
    ValidateContactError(contact) &&
    ValidateContactErrorList(contact) &&
    ValidateContactBankAccountErrorList(contact)
  ) {
    return true;
  } else {
    return false;
  }
}

export function ExceptionInsertContactTemplate(res: any, contact: ContactCreateTemplateModel) {
  switch (res.exception.code) {
    case PeakExceptionResponseCode.ContactCodeIsDuplicated:
      contact.contactCode.validateError = true;
      return i18n.t("Duplicate_Contact_Code_Please_Enter_New_Contact_Code");
      break;
    case PeakExceptionResponseCode.ContactNameIsDuplicated:
      if (
        contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
        contact.typeCompany.value == MerchantType.OrdinaryPerson
      ) {
        contact.firstname.validateError = true;
        contact.lastname.validateError = true;
      } else {
        contact.companyName.validateError = true;
      }
      return i18n.t("Create_contact_failed_because_contact_name_is_duplicated");
      break;
    case PeakExceptionResponseCode.MerchantIsNotAllowDuplicateContactTaxId:
    case PeakExceptionResponseCode.TaxIdIsDuplicated:
      return i18n.t("Tax_Registration_Number_Is_Already_Added_Your_Contact");
      break;
    case PeakExceptionResponseCode.MerchantIsNotAllowDuplicateContact:
      if (
        contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
        contact.typeCompany.value == MerchantType.OrdinaryPerson
      ) {
        contact.firstname.validateError = true;
        contact.lastname.validateError = true;
      } else {
        contact.companyName.validateError = true;
      }
      return i18n.t("Create_contact_failed_because_contact_name_is_duplicated");
      break;
    case PeakExceptionResponseCode.ContactPersonNamePrefixOtherMaxLength:
    case PeakExceptionResponseCode.ContactNamePrefixOtherMaxLength:
      return i18n.t("Contact_Prefix_Incorrect_Format");
      break;
  }
}

export function ExceptionCheckDuplicate(res: any, contact: ContactCreateTemplateModel) {
  const contactDuplicate: any = {
    contactName: "",
    contactNameIsDuplicated: false,
  };
  switch (res.exception.code) {
    case PeakExceptionResponseCode.ContactNameIsDuplicated:
      contactDuplicate.contactName =
        contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
        contact.typeCompany.value == MerchantType.OrdinaryPerson
          ? contact.firstname.value + " " + contact.lastname.value
          : contact.companyName.value;
      contactDuplicate.contactNameIsDuplicated = true;
      break;
    case PeakExceptionResponseCode.TaxIdIsDuplicated:
      contactDuplicate.contactName = contact.taxId;
      contactDuplicate.contactNameIsDuplicated = true;
      break;
    case PeakExceptionResponseCode.MerchantIsNotAllowDuplicateContact:
      contactDuplicate.contactName =
        contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
        contact.typeCompany.value == MerchantType.OrdinaryPerson
          ? contact.firstname.value + " " + contact.lastname.value
          : contact.companyName.value;
      contactDuplicate.contactNameIsDuplicated = true;
      break;
  }
  return contactDuplicate;
}
export function GetBusinessType(merchantType: MerchantType) {
  let typeName = "-";
  switch (merchantType) {
    case 1:
      typeName = i18n.t("Limited_Partnership").toString();
      break;
    case 2:
      typeName = i18n.t("Company_Limited").toString();
      break;
    case 3:
      typeName = i18n.t("Public_Company_Limited").toString();
      break;
    case 4:
      typeName = i18n.t("Shop").toString();
      break;
    case 5:
      typeName = i18n.t("Human").toString();
      break;
    case 6:
      typeName = i18n.t("Body_of_Persons").toString();
      break;
    case 7:
      typeName = i18n.t("Others").toString();
      break;
    case 8:
      typeName = i18n.t("Ordinary_Partnership").toString();
      break;
    case 9:
      typeName = i18n.t("Foundation").toString();
      break;
    case 10:
      typeName = i18n.t("Association").toString();
      break;
    case 11:
      typeName = i18n.t("Joint_Venture").toString();
      break;
  }
  return typeName;
}

export async function GetContactCodeForCreateOrEdit(contactId: number) {
  await store.dispatch("Contact/DoGetContactByContactIdList", [contactId], { root: true });
  return new Promise<string>((resolve) => {
    const contactList = store.getters["Contact/getContactModelList"];
    const contact = contactList.find((x: any) => x.id === contactId);
    if (contact) {
      resolve(contact.contactCode);
    }
    resolve("");
  });
}

export async function GetContactModelByContactId(contactId: number) {
  await store.dispatch("Contact/DoGetContactByContactIdListAsync", [contactId], { root: true });
  return new Promise<any>((resolve) => {
    const contactList = store.getters["Contact/getContactModelList"];
    const contact = contactList.find((x: any) => x.id === contactId);
    if (contact) {
      resolve({ ...contact });
    }
    resolve(null);
  });
}

export function CreateAddressDefault() {
  const addressList: any = {
    postalCode: "",
    province: "",
    district: "",
    subdistrict: "",
    addressPerson: "",
  };
  return addressList;
}
export function SplitAddress(address: any) {
  let splitaddresslist = [];
  if (address) {
    splitaddresslist = address
      .split(/\s|ต\.|อ\.|จ\.|ข\.|เขต|แขวง|ตำบล|อำเภอ|จังหวัด|ตำบล\.|อำเภอ\.|จังหวัด\./)
      .filter((item: any) => item !== "");
  }
  return splitaddresslist;
}
export function CheckPostalCodeInAddress(splitaddresslist: any) {
  return /\d/.test(splitaddresslist[splitaddresslist.length - 1]);
}
export function GetAddressPerson(addressList: any, subdistrict: any) {
  let addressPerson: any = "";
  for (const x in addressList) {
    if (addressList[x] == subdistrict) {
      break;
    } else {
      addressPerson += addressList[x] + " ";
    }
  }
  return addressPerson;
}
export function SetAddressNotPostalCode(address: any) {
  const setAddressNotPostalCode: any = CreateAddressDefault();
  if (address) {
    setAddressNotPostalCode.postalCode = "";
    setAddressNotPostalCode.province = address[address.length - 1];
    setAddressNotPostalCode.district = address[address.length - 2];
    setAddressNotPostalCode.subdistrict = address[address.length - 3];
    setAddressNotPostalCode.addressPerson = GetAddressPerson(address, setAddressNotPostalCode.subdistrict).trim();
  }
  return setAddressNotPostalCode;
}
export function SetAddress(address: any) {
  const setAddress: any = CreateAddressDefault();
  if (address) {
    setAddress.postalCode = address[address.length - 1];
    setAddress.province = address[address.length - 2];
    setAddress.district = address[address.length - 3];
    setAddress.subdistrict = address[address.length - 4];
    setAddress.addressPerson = GetAddressPerson(address, setAddress.subdistrict).trim();
  }
  return setAddress;
}

export function SetPersonToContactDetail(_personToContactDetail: Record<string, any>) {
  const personToContact: Array<Record<string, any>> = [];

  _personToContactDetail.forEach((personToContactItem: Record<string, any>) => {
    personToContact.push({
      id: personToContactItem.id,
      firstName: {
        value: personToContactItem.firstName,
        validateError: false,
      },
      lastName: {
        value: personToContactItem.lastName,
        validateError: false,
      },
      nickName: {
        value: personToContactItem.nickName,
        validateError: false,
      },
      position: {
        value: personToContactItem.position,
        validateError: false,
      },
      email: {
        value: personToContactItem.personEmail,
        validateError: false,
      },
      phoneNumber: {
        value: personToContactItem.personPhone,
        validateError: false,
      },
      prefixName: { value: personToContactItem.personalNamePrefixTypeId },
      prefixOtherName: {
        value: personToContactItem.personalNamePrefixOther,
        validateError: false,
      },
      department: { value: personToContactItem.departmentTypeId },
      departmentOther: {
        value: personToContactItem.departmentOther,
        validateError: false,
      },
    });
  });

  return personToContact;
}

export function SetBankInformation(_bankInformation: Record<string, any>) {
  const bankInformation: Array<Record<string, any>> = [];
  _bankInformation.forEach((bankInformationItem: Record<string, any>) => {
    bankInformation.push({
      id: bankInformationItem.id,
      bank: {
        name: "",
        bankReferenceBankId: bankInformationItem.bankReferenceBankId
          ? bankInformationItem.bankReferenceBankId
          : BankReferenceType.NONE,
      },
      accountName: {
        value: bankInformationItem.accountName,
        validateError: false,
      },
      accountNumber: {
        value: bankInformationItem.accountNumber,
        validateError: false,
      },
      bankBranch: {
        value: bankInformationItem.branch,
        validateError: false,
      },
    });
  });

  return bankInformation;
}

function SetContactGroup(_contactGroup: Record<string, any>) {
  const contactGroupList: Array<Record<string, any>> = [];
  _contactGroup.forEach((contactGroup: Record<string, any>) => {
    contactGroupList.push({
      contactGroupId: contactGroup.id,
      bgLengthColor: contactGroup.color,
      description: contactGroup.description,
      name: contactGroup.name,
    });
  });
  return contactGroupList;
}

export function SetContactTemplateForEdit(contactTemplate: Record<string, any>, contactDetail: Record<string, any>) {
  contactTemplate.modalCreateType = ContactType.Edit;
  contactTemplate.id = contactDetail.id;
  contactTemplate.contactBranchId = contactDetail.contactBranchModel.id;
  contactTemplate.taxId = { value: contactDetail.taxId };
  contactTemplate.branchCode = { value: contactDetail.contactBranchModel.branchCode };
  contactTemplate.branchTypeId = contactTemplate.branchCode.value
    ? contactTemplate.branchCode.value === "00000"
      ? BranchCompanyType.Quarter
      : BranchCompanyType.Branch
    : BranchCompanyType.None;

  contactTemplate.contactContryId =
    (contactTemplate.taxId.value == "" || contactTemplate.taxId.value.length == 13) &&
    contactDetail.contactBranchModel.address.country == "Thailand"
      ? ContactContryType.Thai
      : ContactContryType.Others;

  contactTemplate.contactCode = { value: contactDetail.code };
  contactTemplate.typeCompany = { value: contactDetail.merchantType };
  contactTemplate.typeOfPerson = GetTypeOfPersonBySearchedAddress(contactDetail.merchantType);
  if (
    contactTemplate.typeOfPerson.value === TypeOfPerson.OrdinaryPerson &&
    contactDetail.merchantType === MerchantType.OrdinaryPerson
  ) {
    const fullName = contactDetail.name.split(/ (.*)/);
    contactTemplate.firstname.value = fullName.length > 0 ? fullName[0] : "";
    contactTemplate.lastname.value = fullName.length > 1 ? fullName[1] : "";
    contactTemplate.prefixName = { value: contactDetail.personalNamePrefixType };
    if (contactTemplate.prefixName.value == PrefixNameType.Other) {
      contactTemplate.prefixOtherName = { value: contactDetail.personalNamePrefixOther };
    }
  } else {
    contactTemplate.companyName.value = contactDetail.name;
  }
  contactTemplate.registeredAddress.contactName.value = contactDetail.contactBranchModel.address.contactName;
  contactTemplate.registeredAddress.address.value = contactDetail.contactBranchModel.address.address;
  contactTemplate.registeredAddress.district.value = contactDetail.contactBranchModel.address.subDistrict;
  contactTemplate.registeredAddress.amphoe.value = contactDetail.contactBranchModel.address.district;
  contactTemplate.registeredAddress.province.value = contactDetail.contactBranchModel.address.province;
  contactTemplate.registeredAddress.zipcode.value = contactDetail.contactBranchModel.address.postCode;
  contactTemplate.registeredAddress.road.value = contactDetail.contactBranchModel.address.road;
  contactTemplate.registeredAddress.building.value = contactDetail.contactBranchModel.address.building;
  contactTemplate.registeredAddress.city.value = contactDetail.contactBranchModel.address.district;
  contactTemplate.registeredAddress.state.value = contactDetail.contactBranchModel.address.province;

  contactTemplate.shippingAddress.contactName.value = contactDetail.address.contactName;
  contactTemplate.shippingAddress.address.value = contactDetail.address.address;
  contactTemplate.shippingAddress.district.value = contactDetail.address.subDistrict;
  contactTemplate.shippingAddress.amphoe.value = contactDetail.address.district;
  contactTemplate.shippingAddress.province.value = contactDetail.address.province;
  contactTemplate.shippingAddress.zipcode.value = contactDetail.address.postCode;
  contactTemplate.shippingAddress.road.value = contactDetail.address.road;
  contactTemplate.shippingAddress.building.value = contactDetail.address.building;
  contactTemplate.shippingAddress.city.value = contactDetail.address.district;
  contactTemplate.shippingAddress.state.value = contactDetail.address.province;

  const countryList: Array<any> = [];
  countries.forEach((countrie: Record<string, any>) => {
    const countrieObject = {
      name: countrie.enName,
      code: countrie.alpha2,
    };
    countryList.push(countrieObject);
  });
  contactTemplate.registeredAddress.country = countryList.find(
    (x) => x.name == contactDetail.contactBranchModel.address.country
  );
  contactTemplate.shippingAddress.country = countryList.find((x) => x.name == contactDetail.address.country);

  contactTemplate.email.value = contactDetail.email;
  contactTemplate.phoneNumber.value = contactDetail.phone;
  contactTemplate.website.value = contactDetail.website;
  contactTemplate.faxNumber.value = contactDetail.fax;
  contactTemplate.contactCreditLimit.value = contactDetail.contactCreditLimit.FormatMoney();
  contactTemplate.creditLimitSettingType = contactDetail.creditLimitSettingType;

  if (contactDetail.personToContact && contactDetail.personToContact.length > 0) {
    contactTemplate.personToContact = SetPersonToContactDetail(contactDetail.personToContact);
  }

  if (contactDetail.bankInformation && contactDetail.bankInformation.length > 0) {
    contactTemplate.bankInformation = SetBankInformation(contactDetail.bankInformation);
  }

  if (contactDetail.groupList && contactDetail.groupList.length > 0) {
    contactTemplate.contactGroup = SetContactGroup(contactDetail.groupList);
  }

  contactTemplate.setDueDate.dayForExpenses.value = contactDetail.invoiceExpenseValue;
  contactTemplate.setDueDate.dayForInvoicePayment.value = contactDetail.invoiceIncomeValue;

  contactTemplate.setDueDate.dueToExpenses = { value: contactDetail.invoiceExpenseType };
  contactTemplate.setDueDate.dueToInvoicePayment = { value: contactDetail.invoiceIncomeType };

  contactTemplate.accountRecordSetting.selectReceivableRecorded = { id: contactDetail.accountsReceivableAccountId };
  contactTemplate.accountRecordSetting.selectPayableRecorded = { id: contactDetail.accountsPayableAccountId };
}
